<template>
  <div>
    <div class="topdown-db">
      <div v-if="currentTab !== 'kplh'">
        <div v-if="isEdit === false">
          <a class="mr20" @click="editShow">EDIT</a>
        </div>
        <div v-else>
          <a class="mr20" @click="editShow">CANCEL</a>
          <a class="mr20" @click="addShow" v-if="content !== 'tujuan_pendaftaran'">ADD</a>
        </div>
      </div>
    </div>
    <!-- Legal Doc -->
    <KBLI v-if="isAdd & (content === 'kbli')" @closeModal="closeModal" />
    <DKBLI v-if="isAdd & (content === 'dkbli')" @closeModal="closeModal" />
    <IUJP v-if="isAdd & (content === 'iujp')" @closeModal="closeModal" />
    <SBUJK v-if="isAdd & (content === 'sbujk')" @closeModal="closeModal" />
    <IUJPTL v-if="isAdd & (content === 'iujptl')" @closeModal="closeModal" />
    <INUBBM v-if="isAdd & (content === 'inu_bbm')" @closeModal="closeModal" />
    <SIUPAL v-if="isAdd & (content === 'siupal')" @closeModal="closeModal" />
    <Negara v-if="isAdd & (content === 'negara')" @closeModal="closeModal" />
    <Provinsi v-if="isAdd & (content === 'provinsi')" @closeModal="closeModal" />
    <Kota v-if="isAdd & (content === 'kota')" @closeModal="closeModal" />
    <Kecamatan v-if="isAdd & (content === 'kecamatan')" @closeModal="closeModal" />
    <Kelurahan v-if="isAdd & (content === 'kelurahan')" @closeModal="closeModal" />

    <!-- Tiket Vendor -->
    <Kategori v-if="isAdd & (content === 'kategori')" @closeModal="closeModal" />
    <TujuanPendaftaran v-if="isAdd & (content === 'tujuan_pendaftaran')" @closeModal="closeModal" />

    <!-- K3L -->
    <NonInti v-if="isAdd & (content === 'non_inti')" @closeModal="closeModal" />
    <GoldenRules v-if="isAdd & (content === 'golden_rules')" @closeModal="closeModal" />
    <KBUB v-if="isAdd & (content === 'kbub')" @closeModal="closeModal" />

    <!-- SAP -->
    <BisnisUnit v-if="isAdd & (content === 'bisnis_unit')" @closeModal="closeModal" />
    <TipeBisnisUnit v-if="isAdd & bisnisUnitList.includes(content)" @closeModal="closeModal" :content="content"
      :unitId="getBisnisUnitId()" />
  </div>
</template>

<script>
export default {
  props: {
    isEdit: Boolean,
    content: String,
    currentTab: String,
  },

  components: {
    // Legal Doc
    KBLI: () => import('@/views/MasterData/Add/LegalDoc/KBLI.vue'),
    DKBLI: () => import('@/views/MasterData/Add/LegalDoc/DKBLI.vue'),
    IUJP: () => import('@/views/MasterData/Add/LegalDoc/IUJP.vue'),
    SBUJK: () => import('@/views/MasterData/Add/LegalDoc/SBUJK.vue'),
    IUJPTL: () => import('@/views/MasterData/Add/LegalDoc/IUJPTL.vue'),
    INUBBM: () => import('@/views/MasterData/Add/LegalDoc/INUBBM.vue'),
    SIUPAL: () => import('@/views/MasterData/Add/LegalDoc/SIUPAL.vue'),
    Negara: () => import('@/views/MasterData/Add/LegalDoc/Negara.vue'),
    Provinsi: () => import('@/views/MasterData/Add/LegalDoc/Provinsi.vue'),
    Kota: () => import('@/views/MasterData/Add/LegalDoc/Kota.vue'),
    Kecamatan: () => import('@/views/MasterData/Add/LegalDoc/Kecamatan.vue'),
    Kelurahan: () => import('@/views/MasterData/Add/LegalDoc/Kelurahan.vue'),

    // Tiket Vendor
    Kategori: () => import('@/views/MasterData/Add/TiketVendor/Kategori.vue'),
    TujuanPendaftaran: () =>
      import('@/views/MasterData/Add/TiketVendor/TujuanPendaftaran.vue'),

    // K3L
    NonInti: () => import('@/views/MasterData/Add/K3L/NonInti.vue'),
    GoldenRules: () => import('@/views/MasterData/Add/K3L/GoldenRules.vue'),
    KBUB: () => import('@/views/MasterData/Add/K3L/KBUB.vue'),

    // K3L
    BisnisUnit: () => import('@/views/MasterData/Add/SAP/BisnisUnit.vue'),
    TipeBisnisUnit: () =>
      import('@/views/MasterData/Add/SAP/TipeBisnisUnit.vue'),
  },

  data() {
    return {
      isAdd: false,
    }
  },

  computed: {
    bisnisUnitData() {
      const result = this.$store.state.mdDatabaseStore.bisnisUnitData
      return result
    },
    bisnisUnitList() {
      const result = this.$store.state.mdDatabaseStore.bisnisUnitData
      const arr = result.map(list => {
        return list.name
      })
      return arr
    },
  },

  methods: {
    editShow() {
      this.$emit('editButton')
    },
    addShow() {
      this.isAdd = true
    },
    closeModal() {
      this.isAdd = false
    },
    getBisnisUnitId() {
      const filterData = this.bisnisUnitData.filter(
        i => i.name == this.content
      )[0]

      return filterData.id
    },
  },
}
</script>
